import coding from './coding';

export default {
  namespaced: false,
  modules: { coding },
  state: {
    activeTab: 'DESIGN'
  },
  getters: {
    activeDesignAndCodingTab(state) {
      return state.activeTab;
    }
  },
  mutations: {
    changeActiveDesignAndCodingTab(state, tabEnum) {
      state.activeTab = tabEnum;
    }
  }
};
